export const colors = {
  black: '#000',
  white: '#fff',
  powderAsh: '#c1c7c5',
  lighterGrey: '#d5d4d4',
  darkGrey: '#a9a9a9',
  gray95: '#f2f2f2',
  darkBlue: '#090c1b',
  mantis: '#7ac142',
  mantisDarker: ' #5a803d',
  transparentMantisDarker: 'rgba(90, 128, 61, 0.3)',
  lighterBlue: '#153c6b',
  brightGreen: '#60f702 ',
  tomato: '#ff6347',
  errorBg: '#f27f6b',
  error: '#821805',
  pureBlue: '#09f',
};
